import styled from 'styled-components'

export const LanguageSwitcherWrapper = styled.div`
  position: relative;

  .language-control {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #7e7e7e;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 0;
    cursor: pointer;
  }

  .globe-icon {
    display: inline-flex;
    color: #7e7e7e;
  }

  .language-current {
    color: #7e7e7e;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  .chevron {
    font-size: 18px;
    color: #7e7e7e;
  }

  .dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: transparent;
    border: 1px solid var(--grey4);
    border-radius: 0 0 10px 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    padding: 16px 20px;
    min-width: 160px;
    background-color: var(--light);
    z-index: 20;
  }

  .dropdown-column {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .dropdown-column button {
    display: inline-flex;
    align-items: center;
    border: 0;
    background: transparent;
    color: #21105d;
    font-size: 15px;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    padding: 0;
    cursor: pointer;
    transition: color 0.2s ease;
  }

  .dropdown-column button:hover,
  .dropdown-column button.active {
    color: var(--blue);
  }

  @media only screen and (max-width: 1023px) {
    .dropdown-menu {
      right: 0;
      left: auto;
    }
  }
`
